export default __webpack_public_path__ + "static/media/fi-br-building-active.79c3c052.svg";